import { useEffect } from "react";

// Embed ufficiale iubenda (Privacy Policy + Cookie Policy): link + loader cdn.iubenda.com/iubenda.js.
// iubenda.js trasforma il link in un pulsante che apre la policy nel modal iubenda ed è riconosciuto dal loro sistema.
export const IubendaEmbed = ({ href, title }) => {
  useEffect(() => {
    const loader = () => {
      const s = document.createElement("script");
      const tag = document.getElementsByTagName("script")[0];
      s.src = "https://cdn.iubenda.com/iubenda.js";
      tag.parentNode.insertBefore(s, tag);
    };
    if (document.readyState === "complete") loader();
    else {
      window.addEventListener("load", loader);
      return () => window.removeEventListener("load", loader);
    }
  }, [href]);

  return (
    <a
      href={href}
      className="iubenda-white iubenda-noiframe iubenda-embed"
      title={title}
      data-testid="iubenda-embed-link"
    >
      {title}
    </a>
  );
};
